import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from "@blueprintjs/icons";
import GoogleMapReact from 'google-map-react';
import React, { Component } from 'react';
import { googleApi } from '../../utils/Constants';
import { completeHeightWeight } from '../styles';
import { getTrip } from '../services/tripApiService'

const Mymarker = ({ text, icon, intent }) => {
  return (
    <Icon id='myIcon' intent={intent} icon={icon} iconSize={22} />
  );
}

// Return map bounds based on list of places
const getMapBounds = (map, maps, places) => {
  const bounds = new maps.LatLngBounds();

  places.forEach((place) => {
    bounds.extend(new maps.LatLng(
      place.lat,
      place.lng,
    ));
  });
  return bounds;
};

// Re-center map when resizing the window
const bindResizeListener = (map, maps, bounds, places) => {
  maps.event.addDomListenerOnce(map, 'idle', () => {
    maps.event.addDomListener(window, 'resize', () => {
      map.fitBounds(bounds);
    });
  });
};

// Fit map to its bounds after the api is loaded
const apiIsLoaded = (map, maps, places) => {
  if (places.length > 1) {
    // Get bounds by our places
    const bounds = getMapBounds(map, maps, places);
    // Fit map to bounds
    map.fitBounds(bounds);
    // Bind the resize listener
    bindResizeListener(map, maps, bounds);
  }
};

class MapContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      places: [],
    };
  }

  componentDidMount() {
    this.interval = setInterval(this.updateMarker, 30000);
    const places = [{ lat: this.props.latitudePickup, lng: this.props.longitudePickup, icon: IconNames.MAP_MARKER, intent: Intent.PRIMARY }]
    if (this.props.longitudeDriver && this.props.latitudeDriver) {
      places.push({ lat: this.props.latitudeDriver, lng: this.props.longitudeDriver, icon: IconNames.DRIVE_TIME, intent: Intent.NONE })
    }
    this.setState({ places: places });
  }

  updateMarker = async () => {
    const trip = await getTrip(this.props.tripNumber);
    const places = [{ lat: trip.pickupLat, lng: trip.pickupLon, icon: IconNames.MAP_MARKER, intent: Intent.PRIMARY }]
    if (trip.lastKnownPositionLat && trip.lastKnownPositionLon) {
      places.push({ lat: trip.lastKnownPositionLat, lng: trip.lastKnownPositionLon, icon: IconNames.DRIVE_TIME, intent: Intent.NONE })
    }
    this.setState({ places: places });
  }

  componentWillUnmount() {
    // Clear the interval right before component unmount
    clearInterval(this.interval);
  }

  render() {
    return (
      <div style={completeHeightWeight}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: googleApi.subscriptionKey }}
          center={{ lat: this.props.latitudePickup, lng: this.props.longitudePickup }}
          defaultZoom={11}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, this.state.places)}
        >
          {this.state.places.map(place => (
            <Mymarker
              lat={place.lat}
              lng={place.lng}
              icon={place.icon}
              intent={place.intent}
            />
          ))}

        </GoogleMapReact>
      </div>
    );
  }
}

export default MapContainer;
